//
// シフトの Excel 取込ダイアログ（F-SFT-02）
//
// シフト作成画面の「ダウンロード」で出力した横持ち Excel を、同じ画面で選択中の店舗・年月に取り込む。
// 取込は プレビュー → 「この内容で取り込む」 の2段階。適用したら親（シフト作成画面）に知らせて再読込してもらう。
// 空欄セルは未設定に戻し、登録済みの区分に無い値はエラー。エラーが1つでもあれば取り込めない（API 側でも反映しない）。
//
export default {
  name: 'shift-import-dialog',
  props: {
    // 画面で選択中の店舗・年月をそのまま使う（ダイアログでは選ばせない）
    shopId: {type: [String, Number], required: true},
    year: {type: [String, Number], required: true},
    month: {type: [String, Number], required: true},
    // シフト表に未保存の変更があるか（取込を実行すると失われることを事前に伝える）
    hasUnsavedChanges: {type: Boolean, default: false}
  },
  created () {
    this.$store.commit('CLEAR_SHIFT_IMPORT')
  },
  data () {
    return {
      file: null,
      running: false,
      inputClear: true
    }
  },
  computed: {
    previewResult () {
      return this.$store.getters.shiftImportPreview
    },
    importResult () {
      return this.$store.getters.shiftImportResult
    },
    notify () {
      return this.$store.getters.shiftIoNotify
    },
    errorCount () {
      return (this.previewResult && this.previewResult.error_rows) ? this.previewResult.error_rows.length : 0
    },
    // エラー行が1つでもあれば取り込めない
    hasErrors () {
      return this.errorCount > 0
    },
    canApply () {
      return !!(this.previewResult && this.previewResult.applied > 0 && !this.hasErrors && !this.running && !this.importResult)
    }
  },
  methods: {
    onFileChange: function (event) {
      var files = event.target.files || event.dataTransfer.files
      this.file = (files && files.length > 0) ? files[0] : null
      // ファイルを選び直したら前のプレビューは捨てる
      this.$store.commit('CLEAR_SHIFT_IMPORT')
    },
    buildFormData: function () {
      var formData = new FormData()
      formData.append('shop_id', this.shopId)
      formData.append('year', this.year)
      formData.append('month', this.month)
      formData.append('file', this.file)
      return formData
    },
    preview: function () {
      if (!this.file || this.running) {
        return
      }
      var self = this
      this.running = true
      this.$store.dispatch('IMPORT_SHIFTS_PREVIEW', {data: this.buildFormData()})
      .then(() => { self.running = false })
      .catch(() => { self.running = false })
    },
    apply: function () {
      if (!this.canApply) {
        return
      }
      var message = this.$t('shift_io.message.apply_confirm')
      if (this.hasUnsavedChanges) {
        message = this.$t('shift_io.message.unsaved_warning') + '\n' + message
      }
      if (!window.confirm(message)) {
        return
      }
      var self = this
      this.running = true
      var callback = function () {
        self.file = null
        self.inputClear = false
        self.$nextTick(function () {
          self.inputClear = true
        })
        self.$emit('applied')
      }
      this.$store.dispatch('IMPORT_SHIFTS', {data: this.buildFormData(), callback: callback})
      .then(() => { self.running = false })
      .catch(() => { self.running = false })
    },
    close: function () {
      this.$emit('close')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-import-dialog.js